<!--
 * @Description: 会员分流页面配置  江苏恩霖客户要求的
-->

<template>
	<div class="wrap">
		<div style="padding-right:360px">
			<phone-ctn>
				<!-- 		<agreement-bar></agreement-bar> -->
			</phone-ctn>
		</div>

		<!-- 导航按钮 -->
		<config-ctn title="预约协议页面">
			<div class="p10">
				<!-- 				<label class=" f12">此配置适用于----- 预约协议页面</label> -->
				<div class="nav">

					<config-item label='背景图'>
						<FaImageUpload :maxCount="1" v-model="project.setting.index.bg" @change="handleChange" />
						<el-input v-model="project.setting.index.bg" v-bind="mOptions" placeholder='页面背景图'
							size='small'></el-input>
					</config-item>


					<config-item label='顶部logo'>
						<FaImageUpload :maxCount="1" v-model="project.setting.index.topLogo" @change="handleChange" />
						<el-input v-model="project.setting.index.topLogo" v-bind="mOptions" placeholder='顶部logo'
							size='small'></el-input>
					</config-item>


					<config-item label='访客入口banner'>
						<FaImageUpload :maxCount="1" v-model="project.setting.index.visitorBanner"
							@change="handleChange" />
						<el-input v-model="project.setting.index.visitorBanner" v-bind="mOptions"
							placeholder='请输入访客入口banner' size='small'></el-input>
					</config-item>


					<config-item label='会员入口banner'>
						<FaImageUpload :maxCount="1" v-model="project.setting.index.memberBanner"
							@change="handleChange" />
						<el-input v-model="project.setting.index.memberBanner" v-bind="mOptions"
							placeholder='请输入会员入口banner' size='small'></el-input>
					</config-item>


				</div>

			</div>
		</config-ctn>

	</div>
</template>

<script>
	// import AgreementBar from "@/components/agreementBar";
	import {
		mapGetters
	} from "vuex";

	export default {
		name: "indexTpl",

		components: {
			// AgreementBar,
		},

		computed: {
			...mapGetters(["project"]),
		},
		mounted() {
			console.log(this.project.setting.index);
			if (this.project.setting.index == undefined) {
				this.project.setting.index = {
					topLogo: ""
				}

			}
		},

		methods: {
			handleChange() {
				console.log('The message is changed.');
			}

		},
	};
</script>

<style lang="scss" scoped>
	.nav-item {
		padding: 10px;
		margin-bottom: 10px;
		border-radius: 2px;
		background-color: #fff;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
</style>